/* F2 ECO Suche */
(function(){
  'use strict';
  var cfgEl = document.getElementById('f2s-config');
  if (!cfgEl || window.F2Search) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};
  (function(){
    var ta = document.createElement('textarea');
    Object.keys(T).forEach(function(k){ if (typeof T[k] === 'string' && T[k].indexOf('&') > -1){ ta.innerHTML = T[k]; T[k] = ta.value; } });
  })();
  var EN = C.locale === 'en';

  var FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSclJ1Bsfm5fGgrMwxl9pO3UdnA2pEkDfHCGkMdnNsBDd07zuQ/formResponse';
  var FORM = { q: 'entry.972316931', src: 'entry.1121226106', n: 'entry.1732267433', open: 'entry.1545833259' };
  var SRC_LABEL = { bar: 'Leiste', icon: 'Lupe', menu: 'Menü', searchpage: 'Suchseite', help: 'Hilfe-Seite' };

  var QUICK = [
    { id: 'calc', url: C.calc, label: T.calc, sub: T.calc_sub, icon: 'calc',
      syn: 'fläche flächenrechner quadratmeter m2 m² menge wieviel wie viel bedarf verbrauch kalkulator rechner kitgröße kit größe area calculator quantity how much coverage' },
    { id: 'sheets', url: C.sheets, label: T.sheets, sub: T.sheets_sub, icon: 'doc',
      syn: 'datenblatt datenblätter produktdatenblatt sicherheitsdatenblatt sdb tds sds msds datasheet data sheet safety download pdf dokumente documents' }
  ];
  var STOP = ['der','die','das','den','dem','des','ein','eine','einen','einem','einer','und','oder','ich','du','mit','wie','was','wo','wann','zu','an','auf','für','fur','im','in','ist','mein','meine','meinen','meinem','kann','muss','bei','von','vom','am','es','f2',
    'bis','welche','welcher','welches','welchen','gibt','hallo','hi','hey','bitte','danke','ihr','wir','mir','mich','uns','sind','wird','werden','hat','habe','haben','hatte','nach','über','uber','aus','auch','noch','schon','so','nicht','kein','keine','man','sie','er','sein','eure','euer','unser','diese','dieser','dieses','dass','wenn','ob','als','aber','denn','zum','zur','beim','etwas','alles','sehr','mehr','gerne','gern','eigentlich','dann','da','hier','soll','sollte','könnt','kannst','könnte','darf',
    'the','a','an','and','or','is','are','my','i','do','does','to','of','for','on','with','what','how','when','can','in','which','there','any','your','you','it','its','be','have','has','get','also','please','hello','thanks','this','that','we','our','me','will','would','should','could','about','at','by','from','if','so','some'];
  var TYPES = {
    'fouling-release coating': T.type_coating, 'primer': T.type_primer, 'cleaner': T.type_cleaner,
    'coating remover': T.type_remover, 'application tools': T.type_tools, 'documentation': T.type_docs
  };

  /* ---------- Hilfen ---------- */
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function norm(s){ return String(s || '').toLowerCase(); }
  function fold(s){
    return norm(s).replace(/ß/g, 'ss').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
      .replace(/th/g, 't').replace(/colour/g, 'color').replace(/grey/g, 'gray').replace(/aluminium/g, 'aluminum');
  }
  function tokens(q){
    var all = norm(q).split(/[\s,.;:!?()\/"'„“”‚‘’]+/).filter(function(t){ return t.length >= 2; });
    var kept = all.filter(function(t){ return STOP.indexOf(t) < 0; });
    return kept.length ? kept : all;
  }
  function isMessage(q){
    var s = String(q || '').trim();
    var w = s.split(/\s+/).filter(function(x){ return /[a-z0-9äöüß]/i.test(x); }).length;
    return w >= 12 || s.length > 90 ||
      /^(hallo|hi|hey|hello|guten (tag|morgen|abend)|grüß gott|gruess gott|servus|moin|liebe[rs]?|sehr geehrte|dear|good (morning|afternoon|evening))\b/i.test(s);
  }
  function mark(text, ts){
    var s = String(text || ''), low = s.toLowerCase(), m = [], i, k;
    for (i = 0; i < s.length; i++) m.push(false);
    ts.forEach(function(t){
      var p = low.indexOf(t);
      while (p > -1){ for (k = p; k < p + t.length; k++) m[k] = true; p = low.indexOf(t, p + t.length); }
    });
    var out = '', open = false;
    for (i = 0; i < s.length; i++){
      if (m[i] && !open){ out += '<mark>'; open = true; }
      if (!m[i] && open){ out += '</mark>'; open = false; }
      out += esc(s[i]);
    }
    if (open) out += '</mark>';
    return out;
  }
  function root(){ return (C.root && C.root !== '/') ? C.root.replace(/\/$/, '') : ''; }
  function localize(u){
    if (!u) return '';
    if (/^\/\//.test(u)) return u;
    var m = String(u).match(/^(https?:\/\/[^\/]+)?(\/.*)?$/i);
    if (!m) return u;
    if (m[1] && !/(^|\.)f2eco\.eu$/i.test(m[1].replace(/^https?:\/\//i, ''))) return u;
    var path = (m[2] || '/').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/';
    if (/^\/pages\/(kontakt|contact)\/?(?=[?#]|$)/i.test(path) && C.contact) return C.contact;
    return root() + path;
  }
  function withWidth(u, w){
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function gtagEvent(name, params){
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('f2_' + name, params); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) {}
  }

  /* ---------- FAQ-Daten ---------- */
  var FAQ = null, faqP = null;
  function loadFaq(){
    if (FAQ) return Promise.resolve(FAQ);
    if (faqP) return faqP;
    var key = 'f2s_faq_' + C.locale;
    try { var c = sessionStorage.getItem(key); if (c){ FAQ = JSON.parse(c); return Promise.resolve(FAQ); } } catch (e) {}
    faqP = fetch(C.faqUrl, { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.text() : '[]'; })
      .then(function(t){
        var d = [];
        try { d = JSON.parse(t); } catch (e) { d = []; }
        if (!Array.isArray(d)) d = [];
        var ta = document.createElement('textarea');
        var dec = function(v){ if (typeof v !== 'string' || v.indexOf('&') < 0) return v; ta.innerHTML = v; return ta.value; };
        d.forEach(function(e){ e.q = dec(e.q); e.a = dec(e.a); e.lb = dec(e.lb); });
        FAQ = d;
        try { if (d.length) sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
        return d;
      })
      .catch(function(){ FAQ = []; return FAQ; });
    return faqP;
  }
  function prep(e){
    if (e._f) return e._f;
    var q = fold(e.q), a = fold(e.a), s = fold(e.s), words = {};
    (q + ' ' + s).split(/[^a-z0-9]+/).forEach(function(w){
      if (w.length >= 5){ words[w] = 1; if (w.length >= 7) words[w.slice(0, w.length - 2)] = 1; }
    });
    return (e._f = { q: q, a: a, s: s, w: Object.keys(words) });
  }
  function hit(t, f){
    if (f.q.indexOf(t) > -1) return 3;
    if (f.s.indexOf(t) > -1) return 2.5;
    if (f.a.indexOf(t) > -1) return 1.5;
    if (t.length >= 6){
      var st = t.slice(0, t.length - (t.length >= 9 ? 3 : 2));
      if (f.q.indexOf(st) > -1) return 2;
      if (f.s.indexOf(st) > -1) return 1.7;
      if (f.a.indexOf(st) > -1) return 1;
    }
    if (t.length >= 8){
      for (var i = 0; i < f.w.length; i++){ if (t.indexOf(f.w[i]) > -1) return 1.4; }
    }
    return 0;
  }
  function need(k){ return k <= 2 ? k : (k === 3 ? 2 : Math.ceil(k / 2)); }
  function rankFaq(ts, n){
    var fts = ts.map(fold).filter(function(t){ return t.length >= 2; });
    if (!fts.length) return [];
    var req = need(fts.length), hits = [];
    (FAQ || []).forEach(function(e){
      var f = prep(e), score = 0, m = 0, strong = false;
      fts.forEach(function(t){ var h = hit(t, f); if (h){ m++; score += h; if (h >= 1.7) strong = true; } });
      if (m < req || !strong) return;
      hits.push({ e: e, score: score + m });
    });
    hits.sort(function(x, y){ return (y.score - x.score) || ((y.e.acc ? 1 : 0) - (x.e.acc ? 1 : 0)) || ((x.e.p || 999) - (y.e.p || 999)); });
    var best = hits.length ? hits[0].score : 0;
    return hits.filter(function(x){ return x.score >= best * 0.4; }).slice(0, n || 3).map(function(x){ return x.e; });
  }
  function popularFaq(){
    return (FAQ || []).filter(function(e){ return e.acc; })
      .sort(function(a, b){ return (a.p || 999) - (b.p || 999); }).slice(0, 4);
  }
  function quickFor(q){
    var ql = norm(q);
    return QUICK.filter(function(k){ return k.url && k.syn.split(' ').some(function(w){ return w && ql.indexOf(w) > -1; }); });
  }

  /* ---------- Shopify-Suche ---------- */
  var SUG = {};
  function suggest(q, signal, limit){
    limit = limit || 3;
    var key = limit === 3 ? q : q + '|' + limit;
    if (SUG[key]) return Promise.resolve(SUG[key]);
    var url = C.suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article,page&resources[limit]=' + limit + '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,tag,body';
    return fetch(url, { credentials: 'same-origin', signal: signal, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var res = (j && j.resources && j.resources.results) || {};
        var out = { products: res.products || [], articles: res.articles || [], pages: res.pages || [] };
        SUG[key] = out;
        return out;
      });
  }

  /* ---------- Bausteine ---------- */
  var ICON = {
    calc: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 12h2M12 12h2M8 16h2M12 16h2"/></svg>',
    doc: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></svg>',
    play: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M10 8.5l5 3.5-5 3.5z"/></svg>',
    book: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2z"/><path d="M8 7h6M8 11h6"/></svg>',
    next: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    chev: '<svg class="f2s-faq__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };
  function label(t){ return '<p class="f2s-label">' + esc(t) + '</p>'; }
  function faqItem(e, ts, withPreview, uid){
    var paras = String(e.a || '').split('¶').map(function(p){ return p.trim(); }).filter(Boolean);
    var more = e.l ? '<a class="f2s-faq__link" href="' + esc(localize(e.l)) + '">' + esc(e.lb || T.more) + ' &rarr;</a>' : '';
    var id = 'f2s-a-' + uid + '-' + esc(e.h);
    return '<li class="f2s-faq' + (withPreview ? '' : ' f2s-faq--pop') + '" data-h="' + esc(e.h) + '">' +
      '<button type="button" class="f2s-faq__q" aria-expanded="false" aria-controls="' + id + '" data-f2s-faq>' +
        '<span>' + (ts ? mark(e.q, ts) : esc(e.q)) + '</span>' + ICON.chev + '</button>' +
      (withPreview && paras.length ? '<p class="f2s-faq__pre">' + esc(paras[0]) + '</p>' : '') +
      '<div class="f2s-faq__a" id="' + id + '">' + paras.map(function(p){ return '<p>' + esc(p) + '</p>'; }).join('') + more + '</div>' +
      (withPreview ? '<button type="button" class="f2s-faq__more" data-f2s-faq data-read="' + esc(T.read) + '" data-less="' + esc(T.less) + '">' + esc(T.read) + '</button>' : '') +
    '</li>';
  }
  function popularBlock(uid){
    var pop = popularFaq();
    if (!pop.length) return '';
    return '<div class="f2s-sec">' + label(T.popular) + '<ul class="f2s-list">' + pop.map(function(e){ return faqItem(e, null, false, uid); }).join('') + '</ul></div>';
  }
  function idleHtml(uid){
    return '<div class="f2s-pad">' +
      '<div class="f2s-sec">' + label(T.frequent) + '<div class="f2s-chips">' +
        '<a class="f2s-chip" href="' + esc(C.calc) + '">' + ICON.calc + esc(T.calc) + '</a>' +
        '<a class="f2s-chip" href="' + esc(C.sheets) + '">' + ICON.doc + esc(T.chip_sheets || T.sheets) + '</a>' +
        '<a class="f2s-chip" href="' + esc(C.video) + '" target="_blank" rel="noopener">' + ICON.play + esc(T.video) + '</a>' +
      '</div></div>' + popularBlock(uid) + '</div>';
  }
  function msgHtml(){
    return '<div class="f2s-msgbox">' +
      '<p class="f2s-none__t">' + esc(T.msg_title) + '</p>' +
      '<p class="f2s-msgbox__p">' + esc(T.msg_text) + '</p>' +
      '<div class="f2s-none__btns"><a class="f2s-btn f2s-btn--dark" href="' + esc(C.contact) + '" data-f2s-draft data-f2s-log="Frage gesendet">' + esc(T.msg_btn) + '</a>' +
      '<a class="f2s-btn f2s-btn--line" href="' + esc(C.cal) + '" target="_blank" rel="noopener" data-f2s-log="Rückruf">' + esc(T.callback) + '</a></div></div>';
  }
  function noneHtml(q, uid){
    if (isMessage(q)) return '<div class="f2s-pad">' + msgHtml() + popularBlock(uid) + '</div>';
    return '<div class="f2s-pad">' +
      '<p class="f2s-none__t">' + esc(String(T.none_title || '').replace('{q}', q)) + '</p>' +
      '<p class="f2s-none__p">' + esc(T.none_text) + '</p>' +
      '<div class="f2s-none__btns"><a class="f2s-btn f2s-btn--dark" href="' + esc(C.contact) + '" data-f2s-draft data-f2s-log="Kontakt">' + esc(T.ask) + '</a>' +
      '<a class="f2s-btn f2s-btn--line" href="' + esc(C.cal) + '" target="_blank" rel="noopener" data-f2s-log="Rückruf">' + esc(T.callback) + '</a></div>' +
      popularBlock(uid) + '</div>';
  }
  function resultsHtml(q, ts, quick, faqs, sug, pending, uid){
    var h = '<div class="f2s-pad">';
    if (isMessage(q)) h += msgHtml();
    if (quick.length){
      h += '<div class="f2s-quick">' + quick.map(function(k){
        return '<a class="f2s-quick__a" href="' + esc(k.url) + '" data-f2s-log="' + esc('Werkzeug: ' + k.label) + '"><span class="f2s-quick__i">' + ICON[k.icon] + '</span>' +
          '<span class="f2s-quick__t"><b>' + esc(k.label) + '</b><span>' + esc(k.sub) + '</span></span>' + ICON.next + '</a>';
      }).join('') + '</div>';
    }
    if (faqs.length){
      h += '<div class="f2s-sec">' + label(T.answers) + '<ul class="f2s-list">' + faqs.map(function(e){ return faqItem(e, ts, true, uid); }).join('') + '</ul></div>';
    }
    if (sug && sug.products.length){
      h += '<div class="f2s-sec">' + label(T.products) + '<ul class="f2s-list">' + sug.products.map(function(p){
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var pt = p.product_type || p.type || '';
        var type = TYPES[norm(pt)] || pt;
        return '<li><a class="f2s-row" href="' + esc(p.url) + '" data-f2s-log="' + esc('Produkt: ' + p.title) + '"><span class="f2s-row__img">' +
          (img ? '<img src="' + esc(withWidth(img, 96)) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
          '<span class="f2s-row__t"><b>' + mark(p.title, ts) + '</b>' + (type ? '<span>' + esc(type) + '</span>' : '') + '</span></a></li>';
      }).join('') + '</ul></div>';
    }
    var guides = sug ? sug.articles.map(function(a){ return { t: a.title, u: a.url, k: /\/blogs\/help\//.test(a.url || '') ? T.kind_guide : T.kind_article }; })
      .concat(sug.pages.map(function(p){ return { t: p.title, u: p.url, k: T.kind_page }; })).slice(0, 3) : [];
    if (guides.length){
      h += '<div class="f2s-sec">' + label(T.guides) + '<ul class="f2s-list">' + guides.map(function(g){
        return '<li><a class="f2s-row" href="' + esc(g.u) + '" data-f2s-log="' + esc(g.k + ': ' + g.t) + '"><span class="f2s-row__img f2s-row__img--icon">' + ICON.book + '</span>' +
          '<span class="f2s-row__t"><b>' + mark(g.t, ts) + '</b><span>' + esc(g.k) + '</span></span></a></li>';
      }).join('') + '</ul></div>';
    }
    if (pending) h += '<p class="f2s-loading" role="status">' + esc(T.loading) + '</p>';
    h += '</div>';
    h += '<a class="f2s-all" href="' + esc(C.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '" data-f2s-log="Alle Ergebnisse"><span>' +
      esc(String(T.all || '').replace('{q}', q)) + '</span>' + ICON.arrow + '</a>';
    return h;
  }

  /* ---------- Messung ---------- */
  var tracked = {}, opened = {};
  function trackSearch(q, entry){
    if (q.length < 3 || tracked[q]) return;
    tracked[q] = 1;
    gtagEvent('search', { search_term: q, search_source: entry === 'searchpage' ? 'searchpage' : (entry === 'help' ? 'help' : 'header'), search_entry: entry || 'bar' });
  }
  var LOG = null, logTimer = null;
  function sameSearch(a, b){ var x = fold(a), y = fold(b); return y.indexOf(x.slice(0, 3)) === 0 || x.indexOf(y.slice(0, 3)) === 0; }
  function logSeen(key, add){
    var seen = [];
    try { seen = JSON.parse(sessionStorage.getItem('f2s_log') || '[]'); } catch (e) { seen = []; }
    if (!Array.isArray(seen)) seen = [];
    if (!add) return seen.indexOf(key) > -1;
    try { seen.push(key); sessionStorage.setItem('f2s_log', JSON.stringify(seen.slice(-80))); } catch (e) {}
    return false;
  }
  function logStart(q, src, n){
    q = String(q || '').trim();
    if (q.length < 3) return;
    if (LOG && LOG.src === src && sameSearch(LOG.q, q)){ LOG.q = q; LOG.n = n; }
    else { logFlush(); LOG = { q: q, src: src, n: n, opened: '' }; }
    clearTimeout(logTimer);
    logTimer = setTimeout(logFlush, 30000);
  }
  function logOpen(label){
    if (!LOG || LOG.opened) return;
    LOG.opened = String(label || '').slice(0, 140);
    logFlush();
  }
  function logFlush(){
    clearTimeout(logTimer);
    var l = LOG; LOG = null;
    if (!l || l.q.length < 3) return;
    var key = l.src + '|' + fold(l.q);
    if (logSeen(key)) return;
    logSeen(key, true);
    var body = new URLSearchParams();
    body.append(FORM.q, l.q.slice(0, 500));
    body.append(FORM.src, SRC_LABEL[l.src] || l.src);
    body.append(FORM.n, String(l.n));
    body.append(FORM.open, l.opened || 'nichts');
    try { if (navigator.sendBeacon && navigator.sendBeacon(FORM_URL, body)) return; } catch (e) {}
    try { fetch(FORM_URL, { method: 'POST', mode: 'no-cors', body: body, keepalive: true }); } catch (e) {}
  }
  window.addEventListener('pagehide', logFlush);
  document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') logFlush(); });
  function onPanelClick(e, q){
    var a = e.target.closest ? e.target.closest('[data-f2s-log]') : null;
    if (!a) return;
    if (a.hasAttribute('data-f2s-draft')){ try { sessionStorage.setItem('f2s_draft', q); } catch (err) {} }
    logOpen(a.getAttribute('data-f2s-log'));
  }
  (function(){
    var d = null;
    try { d = sessionStorage.getItem('f2s_draft'); } catch (e) {}
    if (!d || !C.contact) return;
    var here = location.pathname.replace(/\/$/, ''), target = String(C.contact).replace(/\/$/, '');
    if (here !== target) return;
    var fill = function(){
      var ta = document.querySelector('textarea[name="contact[body]"]');
      if (!ta) return;
      if (!ta.value) ta.value = d;
      try { sessionStorage.removeItem('f2s_draft'); } catch (e) {}
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  })();

  /* ---------- Eine Oberflaeche (Leiste oder Vollbild) ---------- */
  var uidN = 0;
  function Ui(rootEl, opts){
    var self = this;
    this.root = rootEl; this.opts = opts || {}; this.uid = 'u' + (++uidN);
    this.input = rootEl.querySelector('[data-f2s-input]');
    this.panel = rootEl.querySelector('[data-f2s-panel]');
    this.clearBtn = rootEl.querySelector('[data-f2s-clear]');
    this.q = ''; this.timer = null; this.trackTimer = null; this.ctrl = null; this.seq = 0;
    if (!this.input || !this.panel) return;
    this.input.addEventListener('input', function(){ self.onInput(); });
    this.input.addEventListener('focus', function(){ if (!self.opts.overlay) self.open(); });
    rootEl.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      if (self.opts.menu && self.panel.hidden) return;
      e.preventDefault(); self.close(true);
    });
    if (this.clearBtn) this.clearBtn.addEventListener('click', function(){ self.input.value = ''; self.onInput(); self.input.focus(); });
    if (this.input.form) this.input.form.addEventListener('submit', function(){
      if (LOG && LOG.src === self.entryName() && sameSearch(LOG.q, self.q)){ LOG.q = self.q || LOG.q; logOpen('Alle Ergebnisse'); }
    });
    this.panel.addEventListener('click', function(e){
      onPanelClick(e, self.q);
      var b = e.target.closest ? e.target.closest('[data-f2s-faq]') : null;
      if (!b) return;
      var li = b.closest('.f2s-faq');
      if (!li) return;
      var on = !li.classList.contains('is-open');
      li.classList.toggle('is-open', on);
      var q = li.querySelector('.f2s-faq__q');
      if (q) q.setAttribute('aria-expanded', on ? 'true' : 'false');
      var more = li.querySelector('.f2s-faq__more');
      if (more) more.textContent = on ? more.getAttribute('data-less') : more.getAttribute('data-read');
      var h = li.getAttribute('data-h');
      if (on){
        var qs = li.querySelector('.f2s-faq__q span');
        logOpen('Antwort: ' + (qs ? qs.textContent : h));
      }
      if (on && h && !opened[h]){ opened[h] = 1; gtagEvent('faq_open', { faq: h, search_term: self.q, search_source: 'header', search_entry: self.entryName() }); }
    });
  }
  Ui.prototype.open = function(){
    var self = this;
    var v = this.input.value.trim();
    if (v !== this.q){ this.q = v; this.panel.innerHTML = ''; }
    if (this.clearBtn) this.clearBtn.hidden = !this.input.value;
    if (this.opts.menu){
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      if (this.opts.onOpen) this.opts.onOpen();
    } else if (this.opts.inline){
      if (this.q.length < 2) return;
      this.placeInline();
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.root.classList.add('is-open');
    } else if (!this.opts.overlay){
      this.place();
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.root.classList.add('is-open');
    }
    loadFaq().then(function(){ self.run(); });
    if (!this.panel.innerHTML) this.run();
  };
  Ui.prototype.close = function(fromKey){
    logFlush();
    if (this.opts.overlay){ if (this.opts.onClose) this.opts.onClose(); return; }
    if (this.opts.menu){
      if (fromKey){ this.input.value = ''; this.q = ''; if (this.clearBtn) this.clearBtn.hidden = true; this.input.blur(); }
      this.panel.hidden = true;
      this.panel.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
      if (this.opts.onClose) this.opts.onClose();
      return;
    }
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.root.classList.remove('is-open');
    if (fromKey) this.input.blur();
  };
  Ui.prototype.place = function(){
    var r = this.root.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    var w = Math.min(600, vw - 32);
    var left = Math.min(0, vw - 16 - r.left - w);
    this.panel.style.width = w + 'px';
    this.panel.style.left = left + 'px';
    this.panel.style.maxHeight = Math.max(260, vh - r.bottom - 24) + 'px';
  };
  Ui.prototype.placeInline = function(){
    var a = this.input.getBoundingClientRect(), s = this.panel.style;
    s.top = Math.round(a.bottom + window.pageYOffset + 8) + 'px';
    s.left = Math.round(a.left + window.pageXOffset) + 'px';
    s.width = Math.round(a.width) + 'px';
    s.maxHeight = Math.min(560, Math.max(300, window.innerHeight - a.bottom - 24)) + 'px';
  };
  Ui.prototype.onInput = function(){
    var self = this;
    this.q = this.input.value.trim();
    if (this.clearBtn) this.clearBtn.hidden = !this.input.value;
    if (this.opts.inline && this.q.length < 2){ if (!this.panel.hidden) this.close(false); return; }
    if (this.opts.inline && !this.panel.hidden) this.placeInline();
    if (!this.opts.overlay && this.panel.hidden) this.open();
    clearTimeout(this.timer);
    this.timer = setTimeout(function(){ self.run(); }, 120);
  };
  Ui.prototype.run = function(){
    var self = this, q = this.q, seq = ++this.seq;
    clearTimeout(this.trackTimer);
    if (q.length < 2){ if (!this.opts.inline) this.panel.innerHTML = idleHtml(this.uid); return; }
    var ts = tokens(q), quick = quickFor(q), faqs = rankFaq(ts);
    var cached = SUG[q];
    this.paint(q, ts, quick, faqs, cached || null, !cached);
    if (cached){ this.done(q, quick, faqs, cached); return; }
    if (this.ctrl && this.ctrl.abort) this.ctrl.abort();
    this.ctrl = window.AbortController ? new AbortController() : null;
    suggest(q, this.ctrl ? this.ctrl.signal : undefined).then(function(sug){
      if (seq !== self.seq) return;
      self.paint(q, ts, quick, faqs, sug, false);
      self.done(q, quick, faqs, sug);
    }).catch(function(err){
      if (err && err.name === 'AbortError') return;
      if (seq !== self.seq) return;
      var empty = { products: [], articles: [], pages: [] };
      self.paint(q, ts, quick, faqs, empty, false);
      self.done(q, quick, faqs, empty);
    });
  };
  Ui.prototype.paint = function(q, ts, quick, faqs, sug, pending){
    var n = quick.length + faqs.length + (sug ? sug.products.length + sug.articles.length + sug.pages.length : 0);
    if (!n && !pending){ this.panel.innerHTML = noneHtml(q, this.uid); return; }
    this.panel.innerHTML = resultsHtml(q, ts, quick, faqs, sug, pending && !n ? true : false, this.uid);
  };
  Ui.prototype.entryName = function(){ return this.opts.entry || (this.opts.overlay ? (this.entry || 'icon') : 'bar'); };
  Ui.prototype.done = function(q, quick, faqs, sug){
    var n = quick.length + faqs.length + sug.products.length + sug.articles.length + sug.pages.length;
    var entry = this.entryName();
    logStart(q, entry, n);
    this.trackTimer = setTimeout(function(){ trackSearch(q, entry); }, 1200);
  };

  /* ---------- Aufbau ---------- */
  var bar = document.querySelector('[data-f2s-bar]');
  var ov = document.querySelector('[data-f2s-overlay]');
  var barUi = bar ? new Ui(bar, { overlay: false }) : null;
  var ovUi = null, lastFocus = null;

  function closeOverlay(){
    if (!ov || ov.hidden) return;
    logFlush();
    document.removeEventListener('focusin', keepFocus, true);
    ov.hidden = true;
    document.documentElement.classList.remove('f2s-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openOverlay(trigger){
    if (!ov) return;
    var entry = (trigger && trigger.getAttribute && trigger.getAttribute('data-f2s-open')) || 'icon';
    ovUi.entry = entry;
    var drawer = trigger && trigger.closest ? trigger.closest('navigation-drawer') : null;
    if (drawer && typeof drawer.hide === 'function'){
      try { drawer.hide(); } catch (e) {}
      trigger = document.querySelector('[aria-controls="' + drawer.id + '"]') || trigger;
    }
    lastFocus = trigger || document.activeElement;
    ov.hidden = false;
    document.documentElement.classList.add('f2s-lock');
    ovUi.open();
    document.addEventListener('focusin', keepFocus, true);
    setTimeout(function(){ ovUi.input.focus(); }, 30);
  }
  function keepFocus(e){
    if (!ov || ov.hidden){ document.removeEventListener('focusin', keepFocus, true); return; }
    if (e.target && !ov.contains(e.target)) setTimeout(function(){ if (!ov.hidden) ovUi.input.focus(); }, 0);
  }
  if (ov){
    document.body.appendChild(ov);
    ovUi = new Ui(ov, { overlay: true, onClose: closeOverlay });
    var back = ov.querySelector('[data-f2s-close]');
    if (back) back.addEventListener('click', closeOverlay);
  }
  var inlineUis = [];
  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-f2s-open]') : null;
    if (t && ov){ e.preventDefault(); openOverlay(t); return; }
    if (barUi && bar && !bar.contains(e.target) && !barUi.panel.hidden) barUi.close(false);
    inlineUis.forEach(function(u){ if (!u.within(e.target) && !u.panel.hidden) u.close(false); });
  });
  if (bar){
    bar.addEventListener('focusout', function(e){
      if (e.relatedTarget && !bar.contains(e.relatedTarget) && barUi) barUi.close(false);
    });
  }
  window.addEventListener('resize', function(){ if (barUi && !barUi.panel.hidden) barUi.place(); });

  /* ---------- Suche im Menue ---------- */
  var menu = document.getElementById('header-sidebar-menu');
  var menuUi = null;
  if (menu && menu.querySelector('[data-f2s-input]') && menu.querySelector('[data-f2s-panel]')){
    var menuBack = menu.querySelector('[data-f2s-menu-back]');
    menuUi = new Ui(menu, {
      menu: true, entry: 'menu',
      onOpen: function(){ menu.classList.add('f2s-menu-on'); if (menuBack) menuBack.hidden = false; },
      onClose: function(){ menu.classList.remove('f2s-menu-on'); if (menuBack) menuBack.hidden = true; }
    });
    if (menuBack) menuBack.addEventListener('click', function(){ menuUi.close(true); });
    var menuTouch = false;
    menuUi.panel.addEventListener('pointerdown', function(){ menuTouch = true; setTimeout(function(){ menuTouch = false; }, 500); });
    menuUi.input.addEventListener('blur', function(e){
      setTimeout(function(){
        if (menuTouch || menuUi.input.value.trim() || document.activeElement === menuUi.input) return;
        if (e.relatedTarget && menuUi.panel.contains(e.relatedTarget)) return;
        if (document.activeElement && menuUi.panel.contains(document.activeElement)) return;
        menuUi.close(false);
      }, 120);
    });
    if (window.MutationObserver){
      new MutationObserver(function(){
        if (!menu.hasAttribute('open') && !menuUi.panel.hidden){
          menuUi.input.value = ''; menuUi.q = '';
          if (menuUi.clearBtn) menuUi.clearBtn.hidden = true;
          menuUi.close(false);
        }
      }).observe(menu, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function attach(rootEl, opts){
    if (!rootEl || rootEl.__f2s) return rootEl && rootEl.__f2s;
    var u = new Ui(rootEl, Object.assign({ inline: true, entry: 'help' }, opts || {}));
    if (!u.input || !u.panel) return null;
    rootEl.__f2s = u;
    inlineUis.push(u);
    document.body.appendChild(u.panel);
    u.within = function(t){ return !!t && (rootEl.contains(t) || u.panel.contains(t)); };
    var out = function(e){ if (e.relatedTarget && !u.within(e.relatedTarget)) u.close(false); };
    rootEl.addEventListener('focusout', out);
    u.panel.addEventListener('focusout', out);
    window.addEventListener('resize', function(){ if (!u.panel.hidden) u.placeInline(); });
    return u;
  }
  window.F2Search = {
    open: openOverlay, close: closeOverlay, attach: attach,
    api: {
      C: C, T: T, ICON: ICON, TYPES: TYPES,
      esc: esc, norm: norm, tokens: tokens, mark: mark, localize: localize, withWidth: withWidth,
      gtagEvent: gtagEvent, loadFaq: loadFaq, rankFaq: rankFaq, popularFaq: popularFaq, quickFor: quickFor,
      suggest: suggest, isMessage: isMessage, trackSearch: trackSearch,
      logStart: logStart, logOpen: logOpen, logFlush: logFlush, onPanelClick: onPanelClick,
      prefill: function(q){
        [barUi, ovUi].forEach(function(u){
          if (!u || !u.input) return;
          u.input.value = q || '';
          if (u.clearBtn) u.clearBtn.hidden = !q;
        });
      }
    }
  };
  try { document.dispatchEvent(new CustomEvent('f2search:ready')); } catch (e) {}
})();
